import { MessagesTab } from '@/features/leads/components/Detail/Tabs/MessagesTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/leads/lead/$id/messages')({
  component: MessagesTab,
});
